/* eslint-disable @wyz/module/no-relative-import */
import { ConfirmationProvider, ThemeProvider, ToastProvider } from '@wyz/ui';
import { QueryClient, QueryClientProvider } from '@wyz/utils';
import * as React from 'react';
import { BrowserRouter } from 'react-router';
import {
  AnalyticsProvider,
  AuthChecker,
  AuthProvider,
  ConfigProvider,
  DatatableProvider,
  GtmTackingProvider,
  I18nProvider,
  LocaleProvider,
} from '~/common/context';

import AppRouter from './app-router';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry(_, error) {
        // TODO: until we add the Exception handle to return a proper Error code in case of 403
        return !error.message.includes('Access Denied');
      },
    },
  },
});

const Main = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider>
        <BrowserRouter>
          <ConfirmationProvider>
            <ThemeProvider>
              <ToastProvider>
                <AnalyticsProvider>
                  <AuthProvider>
                    <GtmTackingProvider>
                      <LocaleProvider>
                        <I18nProvider>
                          <AuthChecker>
                            <DatatableProvider>
                              <React.Suspense fallback={null}>
                                <AppRouter />
                              </React.Suspense>
                            </DatatableProvider>
                          </AuthChecker>
                        </I18nProvider>
                      </LocaleProvider>
                    </GtmTackingProvider>
                  </AuthProvider>
                </AnalyticsProvider>
              </ToastProvider>
            </ThemeProvider>
          </ConfirmationProvider>
        </BrowserRouter>
      </ConfigProvider>
    </QueryClientProvider>
  );
};

export default Main;
